import { Suspense, useState } from "react";
import {
  deleteControls,
  getInProgressState,
  refreshDeviceStatus,
} from "../../redux/voiceControl-slice";
import { deviceInfoMessages, deviceStatus } from "../../constants/voice";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../components";
import { Dialog } from "../../components";
import cn from "classnames";
import { getSelectedDeviceData } from "../../redux/voiceControl-slice";
import { loadTestComponent } from "../../utils";
import styles from "./VoiceControlsStatusMessage.module.scss";
import { useFormatMessage } from "../../i18n";

const errorMessages = {
  VOICE_INVALID_DEVICE: "error_voice_invalid_device",
  NOT_FOUND: "error_device_not_found",
  VOICE_INVALID_STATE: "error_voice_invalid_state",
  GATEWAY_TIMEOUT: "error_device_time_out",
  SERVER_ERROR: "something_went_wrong",
};

export function VoiceControlsStatusMessage() {
  const [showModal, setShowModal] = useState(false);
  const deviceSelected = useSelector(getSelectedDeviceData);
  const { deleteInProgress } = useSelector(getInProgressState);
  const tr = useFormatMessage();
  const dispatch = useDispatch();

  function handleDeleteControls() {
    dispatch(deleteControls(deviceSelected.cloudId));
    setShowModal(false);
  }

  function handleRefreshDevice() {
    dispatch(refreshDeviceStatus(deviceSelected.cloudId));
  }

  const infoMessagesClassnames = {
    checking: styles.checking,
    offline: styles.offline,
    invalid_device: styles.error,
    invalid_firmware: styles.error,
    reprogrammed: styles.error,
  };

  const genericErrorStatusMessage = {
    icon: deviceStatus["generic_error"],
    message: errorMessages[deviceSelected.error] || errorMessages.SERVER_ERROR,
    className: styles.error,
  };

  const deviceSelectedStatusMessage = {
    icon: deviceStatus[deviceSelected.status || "unselected"],
    message: deviceInfoMessages[deviceSelected.status || "unselected"],
    className: infoMessagesClassnames[deviceSelected.status],
  };

  const canRefresh = [
    "offline",
    "invalid_device",
    "invalid_firmware",
    "empty",
    "licenseAssigned",
    "generic_error",
  ];

  function setInfoMessage() {
    const infoMessage = deviceSelectedStatusMessage.message
      ? deviceSelectedStatusMessage
      : genericErrorStatusMessage;

    return infoMessage;
  }

  const canDelete = ["reprogrammed"];
  const infoMessage = setInfoMessage();

  const TestingWrapper = loadTestComponent(
    () => import("../../components/test/TestingWrapper")
  );

  const VoiceControlTestStatusButtons = loadTestComponent(
    () => import("../../components/test/VoiceControlTestStatusButtons")
  );

  return (
    <div className={styles.voiceControlsStatusMessage}>
      <div className={cn(styles.statusIcon, infoMessage.className)}>
        {infoMessage?.icon}
      </div>
      <div className={styles.textMessage}>{tr(infoMessage.message)}</div>

      {canDelete.includes(deviceSelected.status) && (
        <Button
          loading={deleteInProgress}
          type="submit"
          title={tr("device_delete_controls_button")}
          disabled={deleteInProgress}
          variant="danger"
          onClick={() => {
            setShowModal(true);
          }}
        />
      )}
      {canRefresh.includes(deviceSelected.status) && (
        <Button
          loading={false}
          type="submit"
          title={
            deviceSelected.status === "licenseAssigned"
              ? tr("device_refresh_button_lic")
              : tr("device_refresh_button")
          }
          disabled={false}
          variant="primary"
          onClick={handleRefreshDevice}
        />
      )}
      <Dialog
        content={tr(
          "this_operation_is_not_reversible_are_you_sure_you_want_to_delete_all_your_controls"
        )}
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        buttons={[
          {
            title: tr("no_go_back"),
            handler: () => setShowModal(false),
            variant: "light",
          },
          {
            title: tr("yes_i_want_to_proceed"),
            handler: handleDeleteControls,
            variant: "danger",
          },
        ]}
      />
      <Suspense fallback={<></>}>
        <TestingWrapper>
          <VoiceControlTestStatusButtons />
        </TestingWrapper>
      </Suspense>
    </div>
  );
}
